module.exports = __webpack_public_path__ + "assets/36c182c6-ef98-4021-9b0d-d63122c2bbf5.46ee239f.svg";